import {roundtodp} from "lib/utilities/maths";

export default class Vector2 {
	public x:number = 0;
	public y:number = 0;
	
	constructor(x:number = 0, y:number = 0) {
		this.set(x,y);
	}
	public set(x:number, y:number):Vector2 {
		this.x = x;
		this.y = y;
		
		return this;
	}
	public add(x:number, y:number):Vector2 {
		this.x += x;
		this.y += y;
		
		return this;
	}
	public sub(x:number, y:number):Vector2 {
		this.x -= x;
		this.y -= y;
		
		return this;
	}
	public subv(v:Vector2):Vector2 {
		this.x -= v.x;
		this.y -= v.y;
		
		return this;
	}
	public div(d:number):Vector2 {
		this.x /= d;
		this.y /= d;
		
		return this;
	}
	public mult(m:number):Vector2 {
		this.x *= m;
		this.y *= m;
		
		return this;
	}
	public toArray():Array<number> {
		return [this.x, this.y];
	}
	public getNew():Vector2 {
		return new Vector2(this.x, this.y);
	}
	public distanceTo(v2:Vector2):number {
		const v1:Vector2 = this;
		return Math.sqrt(Math.pow((v2.x-v1.x), 2) + Math.pow(v2.y-v1.y, 2));
	}
	public roundtodp(dp:number):Vector2 {
		this.x = roundtodp(this.x, dp);
		this.y = roundtodp(this.y, dp);
		
		return this;
	}
}